
angular.module('bmsApp.directives')
		.directive('inputLoader', function () {
			return {
				restrict: 'A',
				link: function (scope, element, attrs) {

					scope.$watch(attrs.inputLoader, function (value) {
						if (value) {
							angular.element(element).after("<img src='images/shared/loading-small.gif' id='input_img'>");
						}
						else{
							angular.element(element).next().remove();
						}
					})

				}
			};
		});

